import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IModelNotVerificate } from "../../types/admin";
import { getModelsVerification } from "../../api/user";
import Cookies from "js-cookie";

// interface RegisterResponse {
//   token?: string;
//   warningMessage?: string;
//   user?: {
//     createdAt: Date;
//     email: TEmail;
//     firstName: string;
//     gender: TGender | null;
//     id: number;
//     isVerify: boolean;
//     lastName: string;
//     type: TUserType;
//     updatedAt: Date;
//     username: string;
//   };
// }

interface AdminState {
  models: IModelNotVerificate[];
  loading: boolean;
  error: string | null;
}

const initialState: AdminState = {
  models: [],
  loading: false,
  error: null,
};

export const fetchModelsIsVerify = createAsyncThunk(
  "users/verifications",
  async (_, { rejectWithValue }) => {
    try {
      const models: IModelNotVerificate = await getModelsVerification();

      return { models };
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "An unknown error occurred",
      );
    }
  },
);

// export const register = createAsyncThunk(
//   "user/register",
//   async (userData: IRegisterData, { rejectWithValue, dispatch }) => {
//     try {
//       const response: RegisterResponse = await registerUser(userData);

//       if (response.warningMessage) {
//         if (response.warningMessage.includes("exists")) {
//           return rejectWithValue(response.warningMessage);
//         } else {
//           return rejectWithValue(
//             "An error occurred during registration. Please try again.",
//           );
//         }
//       }

//       if (!response.token) {
//         return rejectWithValue(
//           "An error occurred during registration. Please try again.",
//         );
//       }

//       Cookies.set("accessToken", response.token);
//       await dispatch(fetchUser());
//       return response.token;
//     } catch (error) {
//       return rejectWithValue(
//         error instanceof Error ? error.message : "Sorry, there's been an error",
//       );
//     }
//   },
// );

// export const login = createAsyncThunk(
//   "user/login",
//   async (loginData: ILoginData, { rejectWithValue, dispatch }) => {
//     try {
//       const response: {
//         accessToken: string;
//         message: string;
//       } = await loginUser(loginData);
//       Cookies.set("accessToken", response.accessToken);
//       await dispatch(fetchUser());
//       return response.accessToken;
//     } catch (error) {
//       return rejectWithValue(
//         error instanceof Error ? error.message : "An unknown error occurred",
//       );
//     }
//   },
// );

// export const updateUser = createAsyncThunk(
//   "user/update",
//   async (userData: IRequestPatchUser, { rejectWithValue, dispatch }) => {
//     try {
//       const updatedUser: IUserData = await patchUser(userData);
//       console.log("User data updated successfully!")
//       await dispatch(fetchUser());
//     } catch (error) {
//       return rejectWithValue(
//         error instanceof Error ? error.message : "An unknown error occurred",
//       );
//     }
//   },
// );

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    logout(state) {
      state.models = [];
      Cookies.remove("accessToken");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchModelsIsVerify.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchModelsIsVerify.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchModelsIsVerify.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { logout } = adminSlice.actions;
export default adminSlice.reducer;
